import React, { useEffect, useState, useRef } from "react";
import "./domain.css";

import Healthcare from "../../assets/images/healthcare-inside.png";
import { useLocation } from "react-router-dom";

import { Link } from "react-router-dom";

import AOS from "aos";
import "aos/dist/aos.css";

const HealthcareDomain = () => {
  const [play, setPlay] = useState(false);

  const vidRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
     AOS.init();
  }, []);

  const handlePlay = () => {
    if (vidRef && vidRef.current) {
      if (vidRef.current.paused) {
        setPlay(true);
        vidRef.current.play();
      } else {
        setPlay(false);
        vidRef.current.pause();
      }
    }
  };
  return (
    <>
      <div className="domain-banner healthcare">
        <div className="bgoverlay"></div>
        <div className="container-fluid">
          <div className="content">
            <div
              className="heading"
              data-aos="fade-up"
              data-aos-duration="1500"
            >
              <div className="heading-flex">
                <h2>Healthcare</h2>
                <h4>
                  Redefining Healthcare Training: Empower Your Professionals
                  with Fidus eTraining
                </h4>
                <p>
                  At Fidus, we understand the critical role healthcare
                  professionals play in ensuring patient well-being. In today's
                  rapidly evolving medical landscape, staying informed and
                  up-to-date with the latest protocols and advancements is
                  vital.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="domain-section">
        <div className="domain-banner-circle"></div>
        <div className="domain-section-content">
          <div
            className={play ? "domain-main-img play" : "domain-main-img"}
            
          >
            <img src={Healthcare} alt="" />
            <div className="domain-opq-dummy">
              <div class="step" onClick={handlePlay}>
                {play ? (
                  <>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      id="Bold"
                      viewBox="0 0 24 24"
                      width="40"
                      height="40"
                      fill="#37466F"
                    >
                      <path d="M9,17V7a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1v10a1,1,0,0,1-1,1h-2a1,1,0,0,1-1-1Z"></path>
                      <path d="M14,17V7a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1v10a1,1,0,0,1-1,1h-2a1,1,0,0,1-1-1Z"></path>
                    </svg>
                  </>
                ) : (
                  <>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      id="Bold"
                      viewBox="0 0 24 24"
                      width="70"
                      height="40"
                      fill="#37466F"
                    >
                      <path d="M9,17.879V6.707A1,1,0,0,1,10.707,6l5.586,5.586a1,1,0,0,1,0,1.414l-5.586,5.586A1,1,0,0,1,9,17.879Z"></path>
                    </svg>
                  </>
                )}

                <div class="ripple"></div>
                <div class="ripple"></div>
                <div class="ripple"></div>
              </div>
            </div>
            <div className="domain-player">
              <video ref={vidRef} controls controlsList="nodownload" muted>
                <source src="https://fidusindia.in/assets2/domains/videos/HealthDomain.mp4" />
              </video>
            </div>
          </div>
          <div className="domain-main">
            <div
              className="domain-main-content"
              data-aos="fade-up"
              data-aos-duration="1500"
            >
              {/* <h2>Comprehensive Training Solutions</h2> */}
              <p>
                Traditional training methods can be restrictive and
                time-consuming. Busy schedules often clash with rigid classroom
                settings, leaving knowledge gaps and hindering optimal patient
                care.
              </p>
            </div>
          </div>
          <div className="domain-main reverse">
            <div className="domain-main-content">
              <h2 data-aos="fade-up" data-aos-duration="1500">
                This is where eTraining shines!
              </h2>
              <div className="infographics">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-lg-4">
                      <div
                        className="infographic1"
                        data-aos="fade-up"
                        data-aos-duration="1500"
                      >
                        <h4>Unparalleled Flexibility</h4>
                        <p>Freedom to learn anytime, anywhere</p>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div
                        className="infographic1"
                        data-aos="fade-up"
                        data-aos-duration="1500"
                      >
                        <h4>Standardized Excellence</h4>
                        <p>Consistent knowledge and skillsets</p>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div
                        className="infographic1"
                        data-aos="fade-up"
                        data-aos-duration="1500"
                      >
                        <h4>Effortless Scalability</h4>
                        <p>
                          Keep your workforce equipped with the latest
                          information
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="domain-main">
            <div className="domain-main-content">
              <div className="" data-aos="fade-up" data-aos-duration="1500">
                <h2>Engaging Learning Experiences:</h2>
                <p>
                  Gone are the days of monotonous lectures! We believe in making
                  learning interactive and immersive. Our eTraining modules
                  incorporate:
                </p>
              </div>

              <div className="container-fluid">
                <div className="row">
                  <div className="col-lg-3">
                    <div className="feature one" data-aos="zoom-in" data-aos-duration="1500">
                      <h4>
                        Interactive <br /> Elements
                      </h4>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="feature two" data-aos="zoom-in" data-aos-duration="1500">
                      <h4>
                        Realistic <br /> Simulations
                      </h4>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="feature three" data-aos="zoom-in" data-aos-duration="1500">
                      <h4>Gamification</h4>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="feature four" data-aos="zoom-in" data-aos-duration="1500">
                      <h4>
                        Multimedia <br /> Resources
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="domain-main reverse">
            <div className="domain-main-content" data-aos="fade-up" data-aos-duration="1500">
              <h2>Measurable Results for Continuous Improvement</h2>
              <p>
                Unlike traditional training methods, eTraining offers
                comprehensive performance tracking. Monitor learner progress,
                identify areas needing improvement, and tailor training programs
                to address specific knowledge gaps within your healthcare team.
              </p>
              <h4>
                Ready to revolutionize healthcare training? Contact us today and
                let's discuss how our eTraining solutions can empower your
                healthcare professionals!
              </h4>
              <Link className="read-more-product" to={"/request"}>
                <span>Contact Us !</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HealthcareDomain;
